module.exports = __webpack_public_path__ + "static/media/Tonga.7df73136.png";